import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "uk-card-small uk-card-default" }
const _hoisted_2 = { class: "uk-card-header" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { class: "uk-card-body" }
const _hoisted_9 = { "uk-grid": "" }
const _hoisted_10 = { class: "uk-width-1-1" }
const _hoisted_11 = { "uk-grid": "" }
const _hoisted_12 = {
  key: 0,
  class: "uk-width-1-3"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 0,
  class: "uk-margin-remove uk-text-primary"
}
const _hoisted_16 = {
  key: 1,
  class: "uk-margin-remove uk-text-success"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputField = _resolveComponent("InputField")!
  const _component_FilterableDropdown = _resolveComponent("FilterableDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isOceanExport)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_3, "Ocean Export Order Reference"))
        : (_ctx.isLand)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_4, "Land Order Reference"))
          : (_ctx.isRailPickUp)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_5, "Rail Pick-Up Reference"))
            : (_ctx.isRailDropOff)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_6, "Rail Delivery Reference"))
              : (_openBlock(), _createElementBlock("h4", _hoisted_7, "Ocean Import Order Reference"))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_ctx.isOceanExport || _ctx.isOceanImport)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_ctx.isOceanExport)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createVNode(_component_InputField, {
                          modelValue: _ctx.orderData.bookingNumber,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.orderData.bookingNumber) = $event)),
                          id: "bkgNumber",
                          label: "Booking Number"
                        }, null, 8, ["modelValue"])
                      ]))
                    : (_ctx.isOceanImport)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _cache[6] || (_cache[6] = _createElementVNode("label", {
                            for: "blNumber",
                            class: "uk-form-label"
                          }, "Bill of Lading Number", -1)),
                          _createVNode(_component_FilterableDropdown, {
                            taggable: "",
                            "push-tag": "",
                            modelValue: _ctx.orderData.billOfLadingNumber,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.orderData.billOfLadingNumber) = $event)),
                            options: _ctx.mappedBLs,
                            onInput: _ctx.selectBL,
                            components: { OpenIndicator: null, Deselect: null }
                          }, null, 8, ["modelValue", "options", "onInput"]),
                          (
                    _ctx.orderData.billOfLadingNumber &&
                      _ctx.orderData.billOfLadingNumber.length > 4 &&
                      !_ctx.doesBLExist()
                  )
                            ? (_openBlock(), _createElementBlock("p", _hoisted_15, " Bill of Lading does not exist, will create a new Bill of Lading " + _toDisplayString(_ctx.orderData.billOfLadingNumber), 1))
                            : (
                    _ctx.orderData.billOfLadingNumber &&
                      _ctx.orderData.billOfLadingNumber.length > 4 &&
                      _ctx.doesBLExist()
                  )
                              ? (_openBlock(), _createElementBlock("p", _hoisted_16, " Already Tracking " + _toDisplayString(_ctx.activeBLs[_ctx.mappedBLs.indexOf(_ctx.orderData.billOfLadingNumber)].containers.length) + " containers for BL ", 1))
                              : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_InputField, {
              class: _normalizeClass({
                'uk-width-1-3': _ctx.isOceanImport || _ctx.isOceanExport || _ctx.isLand,
                'uk-width-1-2': _ctx.isRailPickUp || _ctx.isRailDropOff,
              }),
              id: "CustomerRef",
              label: "Customer Reference #",
              modelValue: _ctx.orderData.customerReference,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.orderData.customerReference) = $event))
            }, null, 8, ["class", "modelValue"]),
            _createVNode(_component_InputField, {
              class: _normalizeClass({
                'uk-width-1-3': _ctx.isOceanImport || _ctx.isOceanExport || _ctx.isLand,
                'uk-width-1-2': _ctx.isRailPickUp || _ctx.isRailDropOff,
              }),
              id: "CustomerRef",
              label: "Billing Reference #",
              modelValue: _ctx.orderData.billingCustomerReference,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.orderData.billingCustomerReference) = $event))
            }, null, 8, ["class", "modelValue"]),
            (_ctx.settingsOrderShowLinkedOrderNumberField)
              ? (_openBlock(), _createBlock(_component_InputField, {
                  key: 1,
                  class: "uk-width-1-3",
                  id: "LinkedOrderNumber",
                  label: "Linked Master Order #",
                  modelValue: _ctx.orderData.linkedMasterOrderNumber,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.orderData.linkedMasterOrderNumber) = $event))
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            (_ctx.showBrokerFields)
              ? (_openBlock(), _createBlock(_component_InputField, {
                  key: 2,
                  class: "uk-width-1-3 uk-margin-remove-top",
                  id: "HouseBillOfLading",
                  label: "House Bill of Lading Number",
                  modelValue: _ctx.orderData.houseBillOfLading,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.orderData.houseBillOfLading) = $event))
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}